<template>
  <div>
    <hr class="mt-0" />

    <div class="mb-3">
      <div class="display-4 font-3xl text-left">Workflow</div>
    </div>

    <template v-if="process_types.length">
      <div>
        <b-row class="pr-3">
          <schedule-select-button
            v-for="(process_type, index) in process_types"
            :key="index"
            :item="{ value: process_type }"
            :isActive="selected_process_type === process_type"
            :label="process_type"
            icon="share-alt"
            @onClick="onClick"
          ></schedule-select-button>
        </b-row>
      </div>
    </template>

    <div v-else>
      <b-alert show class="mb-4">No process types are available.</b-alert>
    </div>
  </div>
</template>

<script>
import ScheduleSelectButton from "./ScheduleSelectButton";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProcessTypeSelector",

  components: {
    ScheduleSelectButton
  },

  props: {
    process_types: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    ...mapGetters({ schedule_form: "scheduleForm" }),
    selected_sample_type_id() {
      return this.schedule_form.sample_type_id;
    },
    selected_process_type() {
      return this.schedule_form.process_type;
    }
  },

  methods: {
    ...mapActions(["UPDATE_SCHEDULE_FORM"]),

    onClick({ value }) {
      this.UPDATE_SCHEDULE_FORM({
        field: "process_type",
        value
      });
    }
  }
};
</script>
